<script lang="ts" setup>
import { TheNavbar, TheSnackbar } from '~/components';
const route = useRoute();

const showLandingBanner = computed(() => {
  return !['reset-password', 'verify', 'onboarding'].includes(route.name);
});
</script>

<template>
  <v-layout>
    <v-main>
      <TheNavbar />
      <v-row justify="center" no-gutters>
        <v-col v-if="showLandingBanner" class="image-container d-none d-md-block">
          <v-img src="/landing-banner.jpg" class="w-100" height="100vh" cover></v-img>
        </v-col>
        <v-col>
          <NuxtPage />
        </v-col>
      </v-row>
    </v-main>
    <TheSnackbar />
  </v-layout>
</template>

<style lang="scss" scoped>
.image-container {
  max-width: 708px;
}
</style>
